import createReducer from '../../shared/createReducer';
import * as actions from '../constants/action_types';

const initialState = {
    isFetching: true,
    isFetchingDrafts: false,
    trips: {}
};

const requestTrips = (state) => ({
    ...state,
    isFetching: true
})

const receiveTrips = (state, action) => {
    return {
        isFetching: false,
        trips: action.trips
    }
}

const requestDrafts = (state, action) => ({
    ...state,
    isFetchingDrafts: true,
});

const receiveDrafts = (state, action) => ({
    ...state,
    isFetchingDrafts: false,
    trips: {
        ...state.trips,
        drafts: action.drafts
    }
});


const forgotPasswordReducer = createReducer(initialState, {
    [actions.REQUEST_CUSTOMER_HISTORY]: requestTrips,
    [actions.RECEIVE_CUSTOMER_HISTORY]: receiveTrips,
    [actions.REQUEST_CUSTOMER_DRAFTS]: requestDrafts,
    [actions.RECEIVE_CUSTOMER_DRAFTS]: receiveDrafts,
});

export default forgotPasswordReducer;